exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item--chevron[data-v-5762f0c0]:before{border-color:#1a1824}.card-number[data-v-5762f0c0]{font-weight:700;color:var(--global-goodtill-black)}.card-name[data-v-5762f0c0]{font-size:14px;color:var(--global-goodtill-black);opacity:.5;width:100%;margin-top:5px}.default-text[data-v-5762f0c0]{font-size:13px;margin-right:10px;color:var(--global-goodtill-black)}.default-text.active[data-v-5762f0c0]{color:var(--global-goodtill-green);font-weight:700}.preffered-container[data-v-5762f0c0]{font-size:14px;color:var(--global-goodtill-black);width:100%;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5762f0c0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/user/payment_cards.vue
// module id = AYWt
// module chunks = 0